import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import useUser from 'src/hooks/use-user';

import { Typography } from 'src/typography';
import { EmbeddedAccountIcon } from 'src/assets/embedded-account-icon';
import { RadioGroup } from 'shared/components';
import { InputContainer as _InputContainer, InputLabel } from 'src/components/modals/kiosk-checkout/v2/components';

type ConsumerOrderInformationProps = {
  isRecMed: boolean;
  orderType: string;
  switchMenuType: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function ConsumerOrderInformation({
  isRecMed,
  orderType,
  switchMenuType,
}: ConsumerOrderInformationProps): JSX.Element {
  const User = useUser();
  const userFirstName = useObserver(() => User.firstName);
  const userLastName = useObserver(() => User.lastName);
  return (
    <Container>
      <Title tag='h2' size='large'>
        Submitting order for
      </Title>

      <InfoContainer>
        <ThemedEmbeddedAccountIcon width={50} height={50} />

        <InfoText>
          {userFirstName} {userLastName?.charAt(0) ?? ''}.
        </InfoText>
      </InfoContainer>

      {isRecMed && (
        <InputContainer>
          <InputLabel width='100px'>Order Type *:</InputLabel>

          <RadioGroup
            options={[
              {
                label: 'Recreational',
                value: 'rec',
              },
              {
                label: 'Medical',
                value: 'med',
              },
            ]}
            display='inline-block'
            defaultValue={orderType}
            onChange={switchMenuType}
          />
        </InputContainer>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled(Typography.Heading)`
  font-size: clamp(28px, 1.5vw, 32px);
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: clamp(50px, 1.5vw, 56px);
  font-weight: 700;
  margin: 40px 0;
`;

const ThemedEmbeddedAccountIcon = styled(EmbeddedAccountIcon)`
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
`;

const InfoText = styled.div`
  margin-left: 20px;
`;

const InputContainer = styled(_InputContainer)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 64px;
    margin-bottom: 16px;
  }
`;
